export default class Texts {
  // Titles
  static TITLE_SKILLS = 'Skills';
  static TITLE_EXPERIENCE = 'Experience';
  static TITLE_EDUCATION = 'Education';

  // Sentences
  static SENTENCE_MY_DESCRIPTION_FIRST = 'Hi! My name is Varun Sharma.';
  static SENTENCE_MY_DESCRIPTION_SECOND =
    'I am currently working as a Full-Stack Developer at VMware India.';
  static SENTENCE_ABOUT_ME =
    "I'm that person that may go from being cool to a complete nerd faster than the speed of sound (Pun intended).";
  static SENTENCE_FOOTBALL =
    'Also I like watching football (Madridista by heart).';
}
